import Axios from 'axios'

const headers = localStorage.getItem("token") ? { Authorization: ` bearer ${localStorage.getItem("token")}` } : undefined

const http = Axios.create({ headers })

http.interceptors.response.use(r => r, error => {
    if (error.response.status === 503 && window.location.pathname !== '/503') {
        window.location.href = window.location.origin + '/503'
    }

    return error
})

export default http
